import { Component } from '@angular/core';
// import { NgIcon, provideIcons } from '@ng-icons/core';

@Component({
  selector: 'app-about',
  imports: [],
  templateUrl: './about.component.html',
  styles: ``
})
export class AboutComponent {

}
